import { GadgetDetails, TravelSegmentType, MarketingAdditionalItems } from './index';

export interface MarketingInformation{
    gadgetDetails: GadgetDetails;
    travelSegments: TravelSegmentType[];
    ipAddress: string;
    gender: string;
    additionalItems: MarketingAdditionalItems;
    pnr: string;
}